import { useEffect, useState, useRef } from "react";

const settings = [
  "Fly",
  "Conference",
  "BBQ",
  "Lounge",
  "Ski",
  "Lead",
  "Offsite",
  "School run",
];
const INTERVAL = 2000; // ms

export default function RotatingHeadline() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Start rotating only when visible
    if (!isVisible) return;

    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % settings.length);
    }, INTERVAL);

    return () => clearInterval(id);
  }, [isVisible]);

  useEffect(() => {
    // Set up intersection observer to check if component is visible
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div ref={ref} className="w-full py-12 text-center">
      <div className="container px-4 md:px-6">
        <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl mx-auto">
          Swim,<span className="mx-2">Bike,</span>Run,
          <span
            key={settings[index]}
            className="mt-2 relative block text-center animate-fade-in-up motion-reduce:animate-none"
          >
            {settings[index]}
          </span>
        </h2>
        <p className="mx-auto max-w-[700px] text-gray-500 md:text-xl mt-4">
          Your Tritan quarter zip goes wherever you go
        </p>
      </div>
    </div>
  );
}
